import axios from 'axios'
import { cancelPreviousRequest } from '../../../component/helper'
const API_URL = process.env.REACT_APP_THEME_API_URL
const CONSUMER_SURVEY_LIST = `${API_URL}/consumer-survey/list`
const CONSUMER_SURVEY_DETAIL = `${API_URL}/consumer-survey/detail`
const CONSUMER_SURVEY_ADD = `${API_URL}/consumer-survey/add`
const CONSUMER_SURVEY_CALL_LOCK = `${API_URL}/consumer-survey/call-lock`
const CONSUMER_SURVEY_RESPONSE_DATA = `${API_URL}/consumer-survey/response-data`
const CONSUMER_SURVEY_RESPONSE_FORM = `${API_URL}/consumer-survey/response-form`
const CONSUMER_SURVEY_END_CALL = `${API_URL}/consumer-survey/end-call`
const CONSUMER_SURVEY_OTHER_FORM_SUBMIT = `${API_URL}/consumer-survey/other-form-submit`
const CONSUMER_SURVEY_CALL_LIST = `${API_URL}/consumer-survey/call-list`
const CONSUMER_SURVEY_RECALL_LIST = `${API_URL}/consumer-survey/recall-list`
const CONSUMER_SURVEY_PROGRESS_CALL = `${API_URL}/consumer-survey/progress-call`
const CONSUMER_SURVEY_RECENT_CLOSE = `${API_URL}/consumer-survey/recent-close`
const CONSUMER_SURVEY_UNLOCK_CALL = `${API_URL}/consumer-survey/unlock-call`

export const getConsumerSurveyList = (query) => {
    return axios.get(`${CONSUMER_SURVEY_LIST}?${query}`).then((d) => d.data)
}
export const getConsumerSurveyDetail = (id) => {
    return axios.get(`${CONSUMER_SURVEY_DETAIL}/${id}`).then((d) => d.data)
}
export const getConsumerSurveyAdd = (query) => {
    return axios.post(CONSUMER_SURVEY_ADD, query).then((d) => d.data)
}
export const getConsumerSurveyCallLock = (query) => {
    return axios.post(CONSUMER_SURVEY_CALL_LOCK, query).then((d) => d.data?.data)
}
export const getConsumerSurveyResponseData = (query) => {
    return axios.post(CONSUMER_SURVEY_RESPONSE_DATA, query).then((d) => d.data)
}
export const getConsumerSurveyResponseForm = (query) => {
    return axios.post(CONSUMER_SURVEY_RESPONSE_FORM, query).then((d) => d.data)
}
export const getConsumerSurveyEndCall = (query) => {
    return axios.post(CONSUMER_SURVEY_END_CALL, query).then((d) => d.data)
}
export const getConsumerSurveyOtherFormSubmit = (query) => {
    return axios.post(CONSUMER_SURVEY_OTHER_FORM_SUBMIT, query).then((d) => d.data)
}
export const getConsumerSurveyCallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${CONSUMER_SURVEY_CALL_LIST}?${query}`, { signal }).then((d) => d.data)
}
export const getConsumerSurveyRecallList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${CONSUMER_SURVEY_RECALL_LIST}?${query}`, { signal }).then((d) => d.data)
}
export const getConsumerSurveyProgressCall = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${CONSUMER_SURVEY_PROGRESS_CALL}?${query}`, { signal }).then((d) => d.data)
}
export const getConsumerSurveyRecentClose = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${CONSUMER_SURVEY_RECENT_CLOSE}?${query}`, { signal }).then((d) => d.data)
}
export const unlockConsumerSurveyCall = (query) => {
    return axios.post(CONSUMER_SURVEY_UNLOCK_CALL, query).then((d) => d.data)
}